import firebase from 'firebase/app';

export function extractQuery(snapshot: firebase.firestore.QuerySnapshot): any {
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
}

export function getFirestoreInstance() {
  return firebase.firestore();
}
